import Vue from 'vue'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast);

/*

* documentação:
* https://github.com/Maronato/vue-toastification/tree/main#installation

*/